(function (window, document) {
  'use strict';
  if (window.LFSequenceCopy) return;
  var SCENE_LABELS = ['Everyday rituals','Expressive shapes','Within the pile','Between uses','Textured backing','Back to the ritual'];
  // Preserve the original film and its separate narrative beats.
  // Titles follow presented frames, with enough time for each action to finish.
  // Bounded fades complete even if the viewer stops scrolling.
  var COPY = [
    {eyebrow:'SOFT ART FOR EVERYDAY RITUALS',title:'A LITTLE JOY,\nRIGHT UNDERFOOT.',body:'Playful shapes. Soft textures. Everyday comfort.',start:0.32},
    {title:'MADE TO MAKE THE ROOM.',body:'Expressive shapes and tactile texture bring character underfoot.',start:0.94},
    {title:'SOFT ABOVE.\nSTRUCTURED WITHIN.',body:'An illustrated look inside the soft pile.',start:1.53},
    {title:'DRAWN IN.',body:'An illustrated view of moisture entering the pile.',start:2.06},
    {title:'SPREAD OUT.',body:'Moisture spreading between the fibers.',start:2.8},
    {title:'MORE ROOM TO\nAIR OUT.',body:'Allow time to air-dry fully between uses.',start:3.49},
    {title:'SOFT ON TOP.\nGRIPPY UNDERNEATH.',body:'Meet the textured backing beneath the softness.',position:'right',start:4.1},
    {title:'INTO THE WASH.\nBACK TO THE RITUAL.',body:'Machine wash cold · Gentle cycle',start:5.20},
    {eyebrow:'AFTER WASHING',title:'AIR-DRY.\nTHEN ENJOY IT ALL OVER AGAIN.',body:'Air-dry flat. Use only when fully dry.',start:5.67}
  ];
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  function captionAt(story){var key=-1;for(var i=0;i<COPY.length;i++){if(story<COPY[i].start)break;key=i;}return key;}
  function paint(node,value,motionNode){
    value=clamp(value,0,1);
    node.style.opacity=value.toFixed(3);
    (motionNode||node).style.transform='translateY('+((1-value)*10).toFixed(2)+'px)';
    node.setAttribute('aria-hidden',value<0.01?'true':'false');
    node.style.visibility=value<0.001?'hidden':'visible';
  }
  var SHOP_FALLBACK = '/collections/all';

  function headerOffset() {
    var header = document.querySelector('[data-lf-header], .lf-header, .site-header');
    if (!header) return 0;
    return Math.ceil(header.getBoundingClientRect().height);
  }

  function jumpToId(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo(0, Math.max(0, top));
    return true;
  }

  function bindSkipNav(root) {
    var nav = root.querySelector('[data-lf-sequence-skip]');
    if (!nav || nav.getAttribute('data-lf-skip-bound')) return null;
    nav.setAttribute('data-lf-skip-bound', 'true');

    function sync() {
      var show = false;
      if (root.isConnected) {
        var skipLink = nav.querySelector('[data-lf-skip-target]');
        var products = document.getElementById(skipLink ? skipLink.getAttribute('data-lf-skip-target') : 'meet-the-mats');
        var pastProducts = false;
        if (products) {
          pastProducts = products.getBoundingClientRect().top < window.innerHeight - 48;
        }
        if (!pastProducts) {
          var sticky = root.querySelector('.lf-sequence__sticky') || root;
          var rect = sticky.getBoundingClientRect();
          show = rect.bottom > headerOffset() + 120 && rect.top < window.innerHeight - 100;
        }
      }
      nav.classList.toggle('is-off', !show);
      nav.setAttribute('aria-hidden', show ? 'false' : 'true');
      nav.hidden = !show;
    }

    function onClick(event) {
      var node = event.target && event.target.nodeType === 1 ? event.target : event.target.parentElement;
      if (!node || !nav.contains(node)) return;

      var shop = node.closest('[data-lf-skip-shop]');
      if (shop) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
            shop.hasAttribute('download') || (shop.target && shop.target.toLowerCase() !== '_self')) return;
        event.preventDefault();
        event.stopPropagation();
        var href = shop.getAttribute('href') || '';
        if (!href || href === '#' || href === '/') href = SHOP_FALLBACK;
        window.location.assign(href);
        return;
      }

      var skip = node.closest('[data-lf-skip-ahead]');
      if (!skip) return;
      event.preventDefault();
      event.stopPropagation();
      var target = skip.getAttribute('data-lf-skip-target') || 'meet-the-mats';
      if (!jumpToId(target)) window.location.assign(SHOP_FALLBACK);
      sync();
    }

    nav.addEventListener('click', onClick);
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    return function unbindSkipNav() {
      nav.removeEventListener('click', onClick);
      window.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
      nav.removeAttribute('data-lf-skip-bound');
      nav.classList.remove('is-off');
      nav.removeAttribute('aria-hidden');
      nav.hidden = false;
    };
  }


  function CopyLayer(root){
    this.root=root;this.destroyed=false;
    this.endingStill=root.querySelector('.lf-sequence__ending-still');
    var owner=this;
    this.showEndingStill=function(){
      var image=owner.endingStill;
      if(!image||!image.naturalWidth)return;
      var decoded=image.decode?image.decode():Promise.resolve();
      decoded.then(function(){
        if(!owner.destroyed&&image.naturalWidth)image.classList.add('is-decoded');
      }).catch(function(){/* The original presented video remains the fallback. */});
    };
    if(this.endingStill){
      this.endingStill.addEventListener('load',this.showEndingStill);
      if(this.endingStill.complete)this.showEndingStill();
    }
    this.unbindSkip=bindSkipNav(root);
    this.el=root.querySelector('[data-lf-sequence-copy]');
    this.intro=root.querySelector('[data-lf-sequence-intro]');
    this.introInner=this.intro?this.intro.querySelector('.lf-sequence__intro-inner'):null;
    this.counter=root.querySelector('[data-lf-sequence-count]');
    this.label=root.querySelector('[data-lf-sequence-label]');
    this.progress=root.querySelector('[data-lf-sequence-progress]');
    this.shopLink=root.querySelector('[data-lf-skip-shop]');
    this.shopLabel=this.shopLink?this.shopLink.textContent:'';
    this.isFinalShopLabel=false;
    var navOwner=this;
    this.onPhoneResize=function(){navOwner.updateShopLabel();};
    window.addEventListener('resize',this.onPhoneResize);
    this.updateShopLabel();
    this.panels=[];this.activeKey=null;this.shownKey=null;this.captionTimer=0;
    this.reducedMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var self=this;
    COPY.forEach(function(copy,index){
      var panel=document.createElement('div');
      var position=copy.position||'left';
      panel.className='lf-sequence__copy-panel is-'+position;panel.dataset.copyPanel=String(index);panel.dataset.copyPosition=position;
      var content=document.createElement('div');content.className='lf-sequence__copy-content';
      var eyebrow=document.createElement('p');eyebrow.className='lf-sequence__copy-eyebrow';eyebrow.textContent=copy.eyebrow||'';eyebrow.hidden=!copy.eyebrow;
      var title=document.createElement('h2');title.className='lf-sequence__copy-title';title.textContent=copy.title;
      var body=document.createElement('p');body.className='lf-sequence__copy-body';body.textContent=copy.body||'';body.hidden=!copy.body;
      content.appendChild(eyebrow);content.appendChild(title);content.appendChild(body);panel.appendChild(content);
      paint(panel,0,content);self.el.appendChild(panel);self.panels.push({el:panel,content:content});
    });
    this.sync(0,0);
  }
  CopyLayer.prototype.updateShopLabel=function(){
    if(!this.shopLink)return;
    var label=window.innerWidth<=767?'View all mats':(this.isFinalShopLabel?'Meet the mats':this.shopLabel);
    if(this.shopLink.textContent!==label)this.shopLink.textContent=label;
  };
  CopyLayer.prototype.showCaption=function(key,animate){
    this.panels.forEach(function(panel){paint(panel.el,0,panel.content);panel.content.style.animation='none';});
    if(this.intro){this.intro.classList.remove('is-visible');this.intro.setAttribute('aria-hidden','true');}
    if(this.introInner){paint(this.introInner,0);this.introInner.style.animation='none';}
    var selected=key<0?{el:this.introInner,content:this.introInner}:this.panels[key];
    if(key<0&&this.intro){this.intro.classList.add('is-visible');this.intro.setAttribute('aria-hidden','false');}
    if(selected&&selected.el){
      paint(selected.el,1,selected.content);
      selected.content.style.animation=animate&&!this.reducedMotion?'lf-caption-in 180ms ease-out both':'none';
    }
    this.shownKey=key;
    this.root.setAttribute('data-lf-caption-position',key<0?'center':COPY[key].position||'left');
    this.root.setAttribute('data-lf-caption-index',String(key));
    this.el.classList.toggle('is-empty',key<0);
    this.el.setAttribute('aria-hidden',key<0?'true':'false');
  };
  CopyLayer.prototype.setCaption=function(key,cut){
    if(key===this.activeKey)return;
    var old=this.shownKey,wasPending=!!this.captionTimer;
    this.activeKey=key;
    if(this.captionTimer){window.clearTimeout(this.captionTimer);this.captionTimer=0;}
    // Fast jumps go straight to the current shot instead of queuing old copy.
    if(cut||old===null||wasPending||Math.abs(key-old)>1||this.reducedMotion){this.showCaption(key,false);return;}
    var selected=old<0?{content:this.introInner}:this.panels[old];
    if(selected&&selected.content)selected.content.style.animation='lf-caption-out 100ms ease-in both';
    var self=this;
    this.captionTimer=window.setTimeout(function(){
      self.captionTimer=0;if(!self.destroyed)self.showCaption(self.activeKey,true);
    },100);
  };
  CopyLayer.prototype.sync=function(sceneIndex,local){
    if(this.destroyed)return;
    sceneIndex=clamp(sceneIndex,0,SCENE_LABELS.length-1);local=clamp(local,0,1);
    this.root.dataset.sequenceScene=String(sceneIndex);
    var story=sceneIndex+local;
    // The mobile extraction's first ending image is index 56 of 89, whereas
    // the video cut is source frame 139 of 219. Compare decoded frame indices;
    // using the video fraction for both exposes mobile image 0057 for one beat.
    var mobile=this.root.getAttribute('data-lf-playback')==='image-frames';
    var ending=sceneIndex===5&&Math.round(local*(mobile?88:218))>=(mobile?56:139);
    var cut=this.root.getAttribute('data-lf-ending-frame')!==(ending?'true':'false');
    this.root.setAttribute('data-lf-ending-frame',ending?'true':'false');
    var finalShopLabel=ending;
    this.root.setAttribute('data-lf-ending',finalShopLabel?'true':'false');
    if(this.shopLink&&finalShopLabel!==this.isFinalShopLabel){
      this.isFinalShopLabel=finalShopLabel;
      this.updateShopLabel();
    }
    this.setCaption(ending?COPY.length-1:captionAt(story),cut);
    var sticky=this.root.querySelector('.lf-sequence__sticky');
    var blend=mobile&&sticky&&sticky.hasAttribute('data-lf-ending-transition');
    if(blend){
      var mix=Number(sticky.getAttribute('data-lf-ending-mix')||0);
      var copyOpacity=ending?clamp((mix-0.15)/0.5,0,1):1;
      this.root.style.setProperty('--lf-ending-copy-opacity',copyOpacity.toFixed(3));
      this.root.setAttribute('data-lf-phone-transition','true');
    }
    if(this.counter)this.counter.textContent=('0'+(sceneIndex+1)).slice(-2)+' / 0'+SCENE_LABELS.length;
    if(this.label)this.label.textContent=SCENE_LABELS[sceneIndex];
    if(this.progress)this.progress.style.transform='scaleX('+(story/SCENE_LABELS.length).toFixed(4)+')';
  };
  CopyLayer.prototype.destroy=function(){
    this.destroyed=true;window.removeEventListener('resize',this.onPhoneResize);if(this.root){this.root.style.removeProperty('--lf-ending-copy-opacity');this.root.removeAttribute('data-lf-phone-transition');}if(this.unbindSkip)this.unbindSkip();this.unbindSkip=null;
    if(this.endingStill){this.endingStill.removeEventListener('load',this.showEndingStill);this.endingStill.classList.remove('is-decoded');this.endingStill=null;}
    if(this.captionTimer){window.clearTimeout(this.captionTimer);this.captionTimer=0;}
    this.panels.forEach(function(panel){panel.el.remove();});this.panels=[];
    if(this.introInner){this.introInner.style.opacity='';this.introInner.style.transform='';this.introInner.style.visibility='';this.introInner.style.animation='';this.introInner.removeAttribute('aria-hidden');}
    if(this.intro){this.intro.classList.add('is-visible');this.intro.setAttribute('aria-hidden','false');}
    this.root.setAttribute('data-lf-caption-position','center');
    if(this.counter)this.counter.textContent='01 / 0'+SCENE_LABELS.length;
    if(this.label)this.label.textContent=SCENE_LABELS[0];
    if(this.progress)this.progress.style.transform='scaleX(0)';
    if(this.shopLink)this.shopLink.textContent=this.shopLabel;
    if(this.root){this.root.removeAttribute('data-lf-ending');this.root.removeAttribute('data-lf-ending-frame');this.root.removeAttribute('data-lf-caption-index');}
    this.root=null;this.el=null;this.intro=null;this.introInner=null;this.progress=null;this.shopLink=null;
  };
  window.LFSequenceCopy={create:function(root){return root&&root.querySelector('[data-lf-sequence-copy]')?new CopyLayer(root):null;}};
})(window,document);
